import Inputmask from 'inputmask/dist/inputmask.es6'
import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min'
import { getUserLang } from '@/plugins/lang'
import { dateFormat } from '@/helpers/dateHelper'

let els = $('.datetimepicker')

let datetimeOptions = {
    sideBySide: true,
    locale: getUserLang(),
    format: dateFormat().moment.dateTime,
    icons: {
        up: "fa fa-1x fa-chevron-up text-blue",
        down: "fa fa-1x fa-chevron-down text-blue",
        next: 'fa fa-1x fa-chevron-right text-blue',
        previous: 'fa fa-1x fa-chevron-left text-blue',
        today: 'fa fa-1x fa-calendar-day text-blue',
        clear: 'fa fa-1x fa-trash text-blue',
        close: 'fa fa-1x fa-xmark text-blue',
    }
}

els.datetimepicker(datetimeOptions);

els.each(function() {
    Inputmask({
        alias: 'datetime',
        inputFormat: dateFormat().inputMask.dateTime,
        placeholder: dateFormat().placeholder.dateTime,
        clearMaskOnLostFocus: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
    }).mask(this)
})

export { datetimeOptions }
